import { render, staticRenderFns } from "./ShippingChangeModal.vue?vue&type=template&id=2f1846a7&scoped=true"
import script from "./ShippingChangeModal.vue?vue&type=script&lang=js"
export * from "./ShippingChangeModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingChangeModal.vue?vue&type=style&index=0&id=2f1846a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1846a7",
  null
  
)

export default component.exports